'use strict';

angular.module('app.mergeInfluencer', [])

.controller('MergeInfluencerController', ['$scope', '$rootScope', '$http', '$modalInstance', '$location', function($scope, $rootScope, $http, $modalInstance, $location){

    $scope.domain = $scope.index.domain;
    $scope.validMerge = false;

    $scope.checkSourceChannel = function(){
        var checkSourceChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.index.id;
        $http.get(checkSourceChannelUrl, {loader: false})
            .success(function(responseCheckSourceChannel){
                $scope.validMerge = true;
         })
            .error(function(responseCheckSourceChannel){
                $scope.validMerge = false;
            })
    }

    $scope.clickTargetRow = function(id){
        $scope.checkedTargetRow = id;
        if ($scope.selectedTargetRow == $scope.checkedTargetRow) {
            $("[name='mergeInfluencer']").removeClass('selected');
            $scope.checkedTargetRow = null;
        }
        $scope.selectedTargetRow = $scope.checkedTargetRow;

        if($scope.checkedTargetRow == $scope.index.id){
            $scope.validMerge = false;
        }else{
            $scope.validMerge = true;
        }
    }

    $scope.searchInfluencers = function(){
        var req = {
            url: $rootScope.apiUrl + 'admin/searchInfluencerById/' + $scope.influencer_id,
            method: 'GET'
        }

        $http(req).success(function(responseSearchInfluencers){
            $scope.targetInfluencers = responseSearchInfluencers.data;
        })
            .error(function(responseSearchInfluencers){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responseSearchInfluencers.message;
            })   
    }

    $scope.checkSourceChannel();

    $scope.mergeInfluencers = function(){
        var mergeInfData = {
            sourceInfluencer: $scope.index.id,
            targetInfluencer: $scope.selectedTargetRow
        }

        var req = {
            url: $rootScope.apiUrl + 'admin/mergeInfluencers',
            method: 'POST',
            data: JSON.stringify(mergeInfData)
        }

        $http(req).success(function(responseMergeInfluencers){
            $scope.closeModal();
        })
            .error(function(responseMergeInfluencers){
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = responseMergeInfluencers.message;
            })
    }

    $scope.closeModal = function(){
        $modalInstance.close();
    }

}])